import { Facebook, Mail, Share2 } from 'lucide-react';

type InstituteSocialActionsProps = {
    email?: string | null;
    facebookHref?: string | null;
    instituteName: string;
};

export default function InstituteSocialActions({ email, facebookHref, instituteName }: InstituteSocialActionsProps) {
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

    const handleShare = async () => {
        if (!currentUrl) {
            return;
        }

        try {
            if (navigator.share) {
                await navigator.share({
                    title: instituteName,
                    url: currentUrl,
                });

                return;
            }

            await navigator.clipboard?.writeText(currentUrl);
        } catch {
            // Sharing can be cancelled by the visitor; no UI fallback is needed here.
        }
    };

    const actionClass =
        'inline-flex h-9 items-center justify-center rounded-full border border-white/25 bg-white/90 px-4 text-sm font-semibold text-[#102015] shadow-sm transition hover:-translate-y-0.5 hover:bg-white hover:text-[#00963f] hover:shadow-md';
    const iconClass =
        'inline-flex h-9 w-12 items-center justify-center rounded-full border border-white/25 bg-white/90 text-[#00963f] shadow-sm transition hover:-translate-y-0.5 hover:bg-white hover:shadow-md';

    return (
        <div className="mt-4 flex flex-wrap items-center justify-center gap-2 md:justify-start">
            <button type="button" onClick={handleShare} className={actionClass} aria-label={`Share ${instituteName}`}>
                <span>Share</span>
                <Share2 className="ml-2 size-4" aria-hidden="true" />
            </button>
            {facebookHref && (
                <a
                    href={facebookHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={iconClass}
                    aria-label={`Open ${instituteName} on Facebook`}
                >
                    <Facebook className="size-4" aria-hidden="true" />
                </a>
            )}
            {email && (
                <a href={`mailto:${email}`} className={iconClass} aria-label={`Email ${instituteName}`}>
                    <Mail className="size-4" aria-hidden="true" />
                </a>
            )}
        </div>
    );
}
